import { Grid, Paper, Typography, Box } from '@mui/material';
import TrendingUp from '@mui/icons-material/TrendingUp';
import TrendingDown from '@mui/icons-material/TrendingDown';

/**
 * Grille de KPIs admin — tiers primary (plus grands) / secondary (compacts).
 * @param {{ widgets: Array, tier?: 'primary' | 'secondary' }} props
 */
export default function WidgetGrid({ widgets = [], tier = 'primary' }) {
  if (!widgets.length) return null;

  const isPrimary = tier === 'primary';

  return (
    <Grid container spacing={1.5}>
      {widgets.map((w, index) => {
        const hero = isPrimary && index === 0;
        return (
          <Grid
            item
            xs={12}
            sm={hero ? 12 : 6}
            md={hero ? 6 : 4}
            lg={hero ? 6 : 4}
            key={w.widgetKey || w.id || w.title}
          >
            <Paper
              sx={{
                p: isPrimary ? 2 : 1.5,
                height: '100%',
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
              }}
            >
              <Typography
                variant="subtitle2"
                color="text.secondary"
                sx={{ letterSpacing: '0.04em' }}
              >
                {w.title}
              </Typography>
              <Typography
                variant={isPrimary ? 'h4' : 'h5'}
                sx={{
                  my: 0.5,
                  fontWeight: 700,
                  color: 'text.primary',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {w.value}
              </Typography>
              {typeof w.trend === 'number' && (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                    color: w.trend >= 0 ? 'success.main' : 'error.main',
                  }}
                >
                  {w.trend >= 0 ? <TrendingUp fontSize="small" /> : <TrendingDown fontSize="small" />}
                  <Typography variant="body2" sx={{ color: 'inherit' }}>
                    {Math.abs(w.trend)}%
                  </Typography>
                </Box>
              )}
            </Paper>
          </Grid>
        );
      })}
    </Grid>
  );
}
